var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-3 mx-n3 d-flex flex-column",
    attrs: {
      "max-width": "480",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "채팅상담 상담내역 상세"
    }
  }), _c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('vertical-table', _vm._b({
    staticStyle: {
      "margin": "-1px 0"
    }
  }, 'vertical-table', {
    items: _vm.items
  }, false))], 1), _c('div', {
    staticClass: "mt-3",
    staticStyle: {
      "max-height": "calc(100vh - 48px - 12px - 56px - 136px - 12px - 12px)",
      "overflow": "hidden"
    }
  }, [_c('chat-room-view-messages', _vm._b({}, 'chat-room-view-messages', {
    messages: _vm.messages
  }, false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }